<template>
  <div class="tag-label" :class="`tag-label-${type}`">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    type: String
  }
}
</script>

<style lang="css" scoped>
.tag-label {
  display: inline-block;
  padding: 8px;
  border: 1px solid #c1c1c1;
  text-shadow: 0 0 1px #c1c1c1;
}
.tag-label-success {
  border-color: #67c23a;
  background-color: #f0f9eb;
  color: #67c23a;
}
.tag-label-danger {
  border-color: #f56c6c;
  background-color: #fef0f0;
  color: #f56c6c;
}
.tag-label-warn {
  border-color: #e6a23c;
  background-color: #fdf6ec;
  color: #e6a23c;
}
</style>
